import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Horario } from '../interfaces/utilidades/horario.interface';

@Injectable({
  providedIn: 'root'
})
export class HorarioService {
  private apiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/horario';

  constructor(private http: HttpClient) {}

  getHorarios(): Observable<Horario[]> {
    return this.http.get<Horario[]>(this.apiUrl);
  }

  createHorario(horario: Horario): Observable<Horario> {
    return this.http.post<Horario>(this.apiUrl, horario);
  }

  verificarHorariosDisponiblesEditar(idReserva: number, fechaReserva: string, idCampo: number): Observable<Horario[]> {
    const body = {
      fecha_reserva: fechaReserva,
      id_campo: idCampo
    };
    return this.http.post<Horario[]>(`${this.apiUrl}/disponibleseditar/${idReserva}`, body);
  }

  verificarHorariosDisponibles(fechaReserva: string, idCampo: number): Observable<Horario[]> {
    const body = {
      fecha_reserva: fechaReserva,
      id_campo: idCampo
    };
    return this.http.post<Horario[]>(`${this.apiUrl}/disponibles`, body);
  }
}
